// filepath: /c:/Users/avsiv/OneDrive/Desktop/Copilot/Game/tic-tac-toe-web-app/src/index.js
import React from 'react';
import ReactDOM from 'react-dom';
import './styles.css'; // Ensure this path is correct
import App from './App';

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);